/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RecommendedInputs */

const en_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

const de_recommended = /** @type {(inputs: RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfohlen`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {RecommendedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recommended = /** @type {((inputs?: RecommendedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RecommendedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recommended(inputs)
	return de_recommended(inputs)
});